import React from 'react';
import styles from '../style.module.scss';
import {Switch} from "antd";
import {useDispatch, useSelector} from "react-redux";
import {DashboardSetting} from "../../../../util/varibles/userSetting";
import {loginActions} from "../../../LoginPage/reducer";
import {selectOneSetting} from "../../../../util/store/selectors";

const ActiveSite: React.FC = () => {
    const dispatch = useDispatch();
    const checked = useSelector(selectOneSetting(DashboardSetting.ACTIVE_SITE))

    const onChange = (value: any) => {
        dispatch(loginActions.updateUserSetting([{[DashboardSetting.ACTIVE_SITE]: value}]))
    };

    return <div className={styles.line}>
        <div className='text-[15px]'>Only active site</div>
        <Switch checked={checked} onChange={onChange}/>
    </div>;
};
export default ActiveSite;
